// extracted by mini-css-extract-plugin
export var chevronIcon = "_9d-2";
export var teamName = "_9d-1";
export var teamSwitcherButton = "_9d-0";